<template>
<toolbar>
	<h2 v-if='heading'><i class="fa fa-bell"></i> {{heading}}</h2>
	<slot></slot>
	
	<div class="controls">
		<nav-tabs :tabs="tabs"></nav-tabs>
	</div>

</toolbar>
</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

export default {

	name: 'NotificationToolbar',
	components: {
		Toolbar,
		NavTabs
	},
	props: ["heading"],
	data() {
		return {
			tabs: [
				{
					label: "Tradetraks News",
					icon: "fa-bullhorn",
					path: "/notifications/news",
				},
				{
					label: "Alerts",
					icon: "fa-bell",
					path: "/notifications/feed",
				},
				{
					label: "Settings",
					icon: "fa-cog",
					path: "/notifications/settings",
				}
			]
		}
	},
	methods: {
		
	},
	created() {
	}
}
</script>
